import { FC } from 'react';
import { ModuleName } from './moduleName';
import { ModUsers } from '../components/Icons/ModUsers';
import { ModRoles } from '../components/Icons/ModRoles';
import { ModConnect } from '../components/Icons/ModConnect';
import { ModSubscriptions } from '../components/Icons/ModSubscriptions';
import { ModLabel } from '../components/Icons/ModLabel';
import { ModTags } from '../components/Icons/ModTags';
import { ModGossip } from '../components/Icons/ModGossip';
import { ModSavedFilters } from '../components/Icons/ModSavedFilters';
import { ModRateClasses } from '../components/Icons/ModRateClasses';
import { ModCalculationScheme } from '../components/Icons/ModCalculationScheme';
import { ModDomainValues } from '../components/Icons/ModDomainValues';
import { ModModelMatrix } from '../components/Icons/ModModelMatrix';
import { ModComponentModel } from '../components/Icons/ModComponentModel';
import { ModTextModel } from '../components/Icons/ModTextModel';
import { ModAuditTrail } from '../components/Icons/ModAuditTrail';
import { ModSurveys } from '../components/Icons/ModSurveys';
import { Dashboard } from '../components/Icons/Dashboard';
import { ModBureaus } from '../components/Icons/ModBureaus';
import { ModEmployers } from '../components/Icons/ModEmployers';
import { ModCandidates } from '../components/Icons/ModCandidates';
import { ModContracts } from '../components/Icons/ModContracts';
import { ModDocuments } from '../components/Icons/ModDocuments';
import { ModTimecards } from '../components/Icons/ModTimecards';
import { ModInvoices } from '../components/Icons/ModInvoices';
import { ModPayslips } from '../components/Icons/ModPayslips';
import { ModPhases } from '../components/Icons/ModPhases';
import { ModIllnessCases } from '../components/Icons/ModIllnessCases';
import { ModReservations } from '../components/Icons/ModReservations';
import { ModPayments } from '../components/Icons/ModPayments';
import { ModJobs } from '../components/Icons/ModJobs';
import { ModWorkflow } from '../components/Icons/ModWorkflow';
import { ModCaowijer } from '../components/Icons/ModCaowijer';
import { ModApplications } from '../components/Icons/ModApplications';
import { ModShare } from '../components/Icons/ModShare';
import { ModAdminMenu } from '../components/Icons/ModAdminMenu';
import { ModCaoNews } from '../components/Icons/ModCaoNews';
import { ModUserMenu } from '../components/Icons/ModUserMenu';
import { ModWageProforma } from '../components/Icons/ModWageProforma';
import { ModFlexwijerJurisprudence } from '../components/Icons/ModFlexwijerJurisprudence';
import { ModFlexwijerNews } from '../components/Icons/ModFlexwijerNews';
import { ModFlexwijerWml } from '../components/Icons/ModFlexwijerWml';
import { ModFlexwijerArticles } from '../components/Icons/ModFlexwijerArticles';
import { Download } from '../components/Icons/Download';
import { ModFlexwijerBlogs } from '../components/Icons/ModFlexwijerBlogs';
import { ModCaoWages } from '../components/Icons/ModCaoWages';
import { ModDocumentTemplate } from '../components/Icons/ModDocumentTemplate';
import { Binoculars } from '../components/Icons/Binoculars';
import { ModFormBuilder } from '../components/Icons/ModFormBuilder';
import { ModFlexNetManager } from '../components/Icons/ModFlexNetManager';
import { ModCandidatePension } from '../components/Icons/ModCandidatePension';
import { Compact } from '../components/Icons/Compact';
import { ModAssessment } from '../components/Icons/ModAssessment';
import { ModSafety } from '../components/Icons/ModSafety';
import { ModAutomationManager } from '../components/Icons/ModAutomationManager';
import { SvgComponentProps } from '../components/Icons/types';
import { FolderOpen } from '../components/Icons/FolderOpen';
import { FolderGear } from '../components/Icons/FolderGear';

export const moduleIconsMap: Record<ModuleName, FC<SvgComponentProps>> = {
	[ModuleName.User]: ModUsers,
	[ModuleName.Role]: ModRoles,
	[ModuleName.Connect]: ModConnect,
	[ModuleName.Customer]: ModSubscriptions,
	[ModuleName.Label]: ModLabel,
	[ModuleName.Tag]: ModTags,
	[ModuleName.NewsAdmin]: ModGossip,
	[ModuleName.SavedFilter]: ModSavedFilters,
	[ModuleName.RateClass]: ModRateClasses,
	[ModuleName.CalculationScheme]: ModCalculationScheme,
	[ModuleName.DomainValue]: ModDomainValues,
	[ModuleName.ModelMatrix]: ModModelMatrix,
	[ModuleName.ComponentModel]: ModComponentModel,
	[ModuleName.TextModel]: ModTextModel,
	[ModuleName.AuditTrail]: ModAuditTrail,
	[ModuleName.SurveyAdmin]: ModSurveys,
	[ModuleName.Dashboard]: Dashboard,
	[ModuleName.Agency]: ModBureaus,
	[ModuleName.Employer]: ModEmployers,
	[ModuleName.Candidate]: ModCandidates,
	[ModuleName.PeriodicComponents]: ModCandidates,
	[ModuleName.Contract]: ModContracts,
	[ModuleName.Document]: ModDocuments,
	[ModuleName.Timecard]: ModTimecards,
	[ModuleName.Invoice]: ModInvoices,
	[ModuleName.Payslip]: ModPayslips,
	[ModuleName.CandidatePhase]: ModPhases,
	[ModuleName.Illness]: ModIllnessCases,
	[ModuleName.CandidateReservation]: ModReservations,
	[ModuleName.Payment]: ModPayments,
	[ModuleName.News]: ModGossip,
	[ModuleName.Job]: ModJobs,
	[ModuleName.Task]: ModWorkflow,
	[ModuleName.Cao]: ModCaowijer,
	[ModuleName.CustomCao]: ModCaowijer,
	[ModuleName.CaoInstance]: ModCaowijer,
	[ModuleName.Application]: ModApplications,
	[ModuleName.Share]: ModShare,
	[ModuleName.Survey]: ModSurveys,
	[ModuleName.AdminMenu]: ModAdminMenu,
	[ModuleName.CaoNews]: ModCaoNews,
	[ModuleName.UserMenu]: ModUserMenu,
	[ModuleName.SalarySearch]: ModWageProforma,
	[ModuleName.Dossier]: ModFlexwijerJurisprudence,
	[ModuleName.Article]: ModFlexwijerNews,
	[ModuleName.Law]: ModFlexwijerWml,
	[ModuleName.Jurisprudence]: ModFlexwijerArticles,
	[ModuleName.LawNews]: ModFlexwijerWml,
	[ModuleName.BloggerPost]: Download,
	[ModuleName.Wml]: ModFlexwijerBlogs,
	[ModuleName.CaoWages]: ModCaoWages,
	[ModuleName.Versions]: ModDocumentTemplate,
	[ModuleName.Binoculars]: Binoculars,
	[ModuleName.MyProfile]: ModCandidates,
	[ModuleName.MyOrganization]: ModBureaus,
	[ModuleName.FormDesigner]: ModFormBuilder,
	[ModuleName.Forms]: ModFormBuilder,
	[ModuleName.FlexNet]: ModFlexNetManager,
	[ModuleName.DocumentTemplate]: ModDocumentTemplate,
	[ModuleName.CandidatePensions]: ModCandidatePension,
	[ModuleName.CompactView]: Compact,
	[ModuleName.CaoWagesRequest]: ModAssessment,
	[ModuleName.Comment]: ModGossip,
	[ModuleName.Proforma]: ModWageProforma,
	[ModuleName.Safety]: ModSafety,
	[ModuleName.Community]: ModGossip,
	[ModuleName.CaoCustomAgreement]: ModCaowijer,
	[ModuleName.Automation]: ModAutomationManager,
	[ModuleName.Connector]: ModConnect,
	[ModuleName.Backoffice]: FolderOpen,
	[ModuleName.BackofficeTransferFiles]: FolderGear,
};
